import { FC, HTMLAttributes, JSX, useId } from 'react';
import { twMerge } from 'tailwind-merge';

import UploadIcon from '@/shared/ui/icons/Upload';

interface DragAndDropZoneProps extends HTMLAttributes<HTMLDivElement> {
  onFileSelected: (file: File | null) => void;
  accept?: string;
}

const DragAndDropZone: FC<DragAndDropZoneProps> = ({
  className,
  onFileSelected,
  accept,
}): JSX.Element => {
  const inputId = useId();

  const handleFiles = (fileList: FileList) => onFileSelected(fileList.item(0));

  return (
    <div
      className={twMerge(
        'flex h-[372px] flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-gray/50',
        className
      )}
      onDrop={(e) => {
        e.preventDefault();
        handleFiles(e.dataTransfer.files);
      }}
      onDragOver={(e) => {
        e.preventDefault();
      }}
      onDragLeave={(e) => {
        e.preventDefault();
      }}
    >
      <UploadIcon />
      <div className="flex flex-col gap-1 text-center">
        <span className="text-sm font-light">
          <input
            type="file"
            id={inputId}
            className="hidden"
            accept={accept}
            onChange={(e) => {
              onFileSelected(e?.target?.files?.[0] ?? null);
            }}
          />
          <span>Drag file here or </span>
          <label htmlFor={inputId} className="cursor-pointer underline">
            choose
          </label>
          <br />
          <span>on computer</span>
        </span>
        <span className="text-small font-light leading-5 text-gray/75">
          {accept}
        </span>
      </div>
    </div>
  );
};

export default DragAndDropZone;
